<template>
	<div>
		<div class="list_box" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled" >
			<div class="p_flex type_size_18">
				<span class="subject_color">{{item.classLevel.name}}</span>
				<el-divider direction="vertical"></el-divider>
				<span class="">{{item.student_name}}</span>
			</div>
			<div class="p_flex p_f_a p_f_b p_m_t_20 type_size_16">
				<span >用时{{item.use_minute}}分钟</span>
				<div class="p_flex ">
					<span class="subject_yellow small_hand" v-if="yc==index">批改中</span>
					<span class="subject_color small_hand" v-else @click="pg(item, index)">去批改</span>
				</div>
			</div>
		</div>
		<!-- <pagination @get="get" :index="num"/> -->
	</div>
</template>

<script>
import pagination from '../../../pagination/pagination.vue'
export default {
	data() {
		return {
			count: [],
			loading: false,
			num:0,
			yc:0
		};
	},
	components: {
		pagination
	},
	created(){
		this.get()
	},
	methods: {
		get(id){
			this.$request.ajax(this).post("/api_teacher/student_correcting_list",{
				job_publish_id: this.$route.query.id,
				page:id?id:1,    //第几页
				limit:10
			}).then(res=>{
				// console.log(res)
				this.count=res.data.list
				this.num=res.data.count
			})
		},
		pg(val,o){
			// console.log(val,o)
			this.$emit("value",val)
			this.yc=o
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/correct/commponents/pupilList.vue